// Remembers where the learner has been, so the home page can offer
// "Continue Learning" and the practice sidebar can show recent topics.

const STORAGE_KEY = 'mathTutor.recentActivity';
const HISTORY_LIMIT = 10;

function entryKey(entry) {
  return entry.majorTopic ? `${entry.grade}::${entry.majorTopic}` : entry.path;
}

export function loadRecentHistory() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    // Older builds stored a single object under this key.
    const list = Array.isArray(parsed) ? parsed : [parsed];
    return list.filter((entry) => entry?.path);
  } catch (e) {
    return [];
  }
}

export function loadRecentActivity() {
  return loadRecentHistory()[0] || null;
}

// Topics the learner actually opened, most recent first.
export function loadRecentTopics(limit = 3) {
  return loadRecentHistory()
    .filter((entry) => entry.majorTopic)
    .slice(0, limit);
}

export function saveRecentActivity(activity) {
  if (!activity?.path) return;
  try {
    const key = entryKey(activity);
    const previous = loadRecentHistory().find((entry) => entryKey(entry) === key);
    const rest = loadRecentHistory().filter((entry) => entryKey(entry) !== key);
    const next = [
      { ...previous, ...activity, updatedAt: Date.now() },
      ...rest,
    ].slice(0, HISTORY_LIMIT);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    // Storage unavailable (private mode, quota) — continuing is optional.
  }
}

export function describeRecentActivity(activity) {
  if (!activity) return '';
  return [activity.grade, activity.majorTopic].filter(Boolean).join(' · ');
}
